<template lang="pug">
  v-container#top(fluid)
    v-layout.jumbotron(column align-center)
      v-flex.jumbotron-contents.text-xs-center
        h1.display-4(style="padding-bottom:0.3em;") Contact Us
    v-layout#about(align-center row wrap)
      v-flex.text-xs-center
        article
          h1.display-1 Discord
          p.subheading 気軽に参加&書き込みしてください。ファッションアスペお断り。
          p.caption バグ報告, アイディア投稿, コンピレーション開催やEP投稿などのご要望もお受けいたしております。
          iframe(src="https://discordapp.com/widget?id=479698005818343425&theme=dark" width="300" height="500" allowtransparency="true" frameborder="0")
        article
          h1.display-1 Supervisor
          v-avator
            img#profile(src="../assets/images/supervisor_avator.png")
            h1.title Trouble_SUM
            p.caption Supervisor / Developer / Designer
            p.body-1 自殺
          v-flex
            v-btn.blue(icon href="https://twitter.com/sometrouble_" target="_blank")
              i.fab.fa-twitter
            v-btn.orange.darken-1(icon href="https://twitter.com/tsuruhashi_rec" target="_blank")
              i.fab.fa-twitter
            v-btn.orange.darken-3(icon href="https://soundcloud.com/trouble_sum" target="_blank")
              i.fab.fa-soundcloud
            v-btn.grey.darken-4(icon href="https://github.com/sometrouble" target="_blank")
              i.fab.fa-github
          
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
h1 {
  padding-bottom: 0.5em;
}
article {
  padding-bottom: 50px;
}
#top {
  padding: 0;
}
#profile {
  width: 200px;
  border-radius: 5%;
}
@mixin display-size-page {
  min-height: 100vh;
  min-width: 100vw;
  padding-right: 10%;
  padding-left: 10%;
}
.jumbotron {
  @include display-size-page;
  background-size: cover;
  background-position: center;
  background-image: url("../assets/images/top.jpg");
}
.jumbotron-contents {
  @include display-size-page;
  padding-top: 30vh;
  background: rgba(0,0,0,0.4)
}
#about {
  @include display-size-page;
  padding-top: 10%;
  padding-bottom: 10%;
}
</style>
